// src/accordion/context.ts
import { createContext } from "react";
var AccordionItemContext = createContext(null);

export {
  AccordionItemContext
};
//# sourceMappingURL=chunk-YQFL5UN4.mjs.map